var default_styles_default = {
  "button_container": "SVhhi",
  "button_margin": "kMLZB",
  "button_text": "oiwsz",
  "button_size_content": "F7UFR"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
